var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6,
    fill: "#F6F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6839 10.75C15.5761 10.75 12.8682 12.4686 11.4613 15.0094L13.0683 14.7589L13.2993 16.2411L10.1223 16.7362L9.55767 16.8242L9.32295 16.3033L8.00003 13.3669L9.36764 12.7508L10.0991 14.3743C11.746 11.3241 14.972 9.25 18.6839 9.25C24.0686 9.25 28.4339 13.6152 28.4339 19C28.4339 24.3848 24.0686 28.75 18.6839 28.75V27.25C23.2402 27.25 26.9339 23.5563 26.9339 19C26.9339 14.4437 23.2402 10.75 18.6839 10.75ZM8.93384 19C8.93384 19.3221 8.94948 19.6407 8.98008 19.9551L10.473 19.8098C10.4471 19.5436 10.4338 19.2735 10.4338 19H8.93384ZM9.35138 21.8309C9.53832 22.448 9.78471 23.039 10.0838 23.5974L11.4061 22.8892C11.1531 22.4169 10.9449 21.9173 10.7869 21.396L9.35138 21.8309ZM11.147 25.1857C11.5522 25.6789 12.0049 26.1316 12.4981 26.5368L13.4503 25.3779C13.0326 25.0347 12.6492 24.6512 12.306 24.2335L11.147 25.1857ZM14.0864 27.6C14.6448 27.8991 15.2359 28.1455 15.8529 28.3325L16.2879 26.8969C15.7665 26.7389 15.2669 26.5307 14.7946 26.2778L14.0864 27.6ZM17.7287 28.7038C18.0431 28.7344 18.3618 28.75 18.6838 28.75V27.25C18.4104 27.25 18.1402 27.2367 17.874 27.2108L17.7287 28.7038ZM17.4338 16V20V20.75H18.1838H21.6838V19.25H18.9338V16H17.4338Z",
    fill: "#9A9AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHistoryIcon);
export default __webpack_public_path__ + "static/media/newHistoryIcon.cfaff9acc9f0cf2ff450a706cff9c555.svg";
export { ForwardRef as ReactComponent };